import React from "react";

const TagsList = ({ tags }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2 mt-2 mb-2">
      {tags.map((tag, idx) => (
        <span
          key={idx}
          className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full"
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

export default TagsList;